export default __webpack_public_path__ + "static/media/all-care.674c4a2f.png";